import React from 'react'
import { ListGroup } from 'react-bootstrap'
import '@szhsin/react-menu/dist/index.css'
import Icon from '@mdi/react'
import { mdiFilePdf, mdiFileWord, mdiFileImage, mdiFileDocument } from '@mdi/js'
import PopupMenu, { MenuItemInfo } from 'components/molecules/PopupMenu'
import './styles.scss'

interface DocumentListViewProps {
  files: File[]
  showPopupMenu: boolean
  popupMenuActions?: MenuItemInfo[]
}

const getIcon = (filename: string): string => {
  const extension = filename.split('.').pop()
  switch (extension) {
    case 'pdf':
      return mdiFilePdf
    case 'doc':
    case 'docx':
      return mdiFileWord
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'png':
    case 'bmp':
      return mdiFileImage
    default:
      return mdiFileDocument
  }
}

const DocumentListView = (props: DocumentListViewProps): JSX.Element => {
  const renderPopUpMenu = (fileIndex: number) => {
    if (!props.showPopupMenu || !props.popupMenuActions) return null

    const newMenu: MenuItemInfo[] = props.popupMenuActions.map((item) => ({
      ...item,
      clickParameter: fileIndex
    }))

    return (
      <span className='float-right'>
        <PopupMenu menuItemList={newMenu} />
      </span>
    )
  }

  if (!props.files) return <h3>No documents</h3>
  return (
    <React.Fragment>
      <ListGroup>
        {props.files.map((file: File, index: number) => (
          <ListGroup.Item key={index} style={{ paddingTop: 15 }}>
            <Icon path={getIcon(file.name)} size={1} className='float-left' />
            <h3 className='float-left ml-1 d-inline-block text-truncate document-item'>
              {file.name}
            </h3>
            {renderPopUpMenu(index)}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </React.Fragment>
  )
}

export default DocumentListView
